import { styled, alpha, lighten } from "@mui/material/styles";
import { Collapse, IconButton } from "@mui/material";
import { SPACING } from "src/_globalStore/redux/reducers/Theme/themeConstants";

export const ChartsInnerContainer = styled(Collapse)({
  position: "relative",
});

export const ChartsToggler = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "hidden" && prop !== "effect",
})<{ hidden: boolean; effect: "expand" | "close" }>(
  ({ theme }) => ({
    boxShadow: theme.shadows[3],
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    "&:hover": {
      backgroundColor: lighten(theme.palette.primary.main, 0.7),
    },
  }),
  ({ effect }) => ({
    ...(effect === "close" && {
      position: "absolute",
      top: SPACING[3], //10
      left: SPACING[3], //10
      zIndex: 10,
    }),
  }),
  ({ hidden }) => ({
    ...(hidden && {
      display: "none",
    }),
  })
);
